import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive } from "vue";
  import Modal from "@/components/ui/Modal.vue";
  import useVuelidate from "@vuelidate/core";
  import { required, email } from "@vuelidate/validators";
  import store from "@/store";
  import { useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SendEoiDocumentsModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    eoiId: {
      type: String,
      required: true,
    },
  },
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const toast = useToast();
  const props = __props;
  const loading = ref(false);

  const form = reactive({
    email: "",
  });
  const rules = {
    email: { required, email },
  };
  const v$ = useVuelidate(rules, form);
  const close = () => {
    emits("close");
  };
  const send = () => {
    v$.value.$touch();

    if (v$.value.$invalid) {
      return;
    }

    loading.value = true;
    store
      .dispatch("eoi/sendEmailWithAttachments", {
        eoiId: props.eoiId,
        email: form.email,
      })
      .then(() => {
        close();
        toast.success("Email was sent successfully");
      })
      .catch((error) => {
        toast.error(error.response.data.message[0]);
      })
      .finally(() => {
        loading.value = false;
      });
  };

const __returned__ = { emits, toast, props, loading, form, rules, v$, close, send, ref, reactive, Modal, get useVuelidate() { return useVuelidate }, get required() { return required }, get email() { return email }, get store() { return store }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})